export default __webpack_public_path__ + "static/media/img_background_login.a7174216.jpg";